import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { environment } from 'src/environments/environment'

import { Character } from '@mmocld/data'

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private url = environment.fdiHttpUrl

  constructor(private http: HttpClient) {}

  findAllCharacters(sub: string) {
    return this.http.get<Character[]>(this.url + `/users/${sub}/characters`)
  }
}
